<template>
  <b-container class="stores-management" fluid>
    <page-title icon="fas fa-store">
      <translate>Stores/Branches/Warehouses Management</translate>
      <template #extras>
        <b-button variant="secondary" size="sm" @click="openNew">
          <font-awesome-icon icon="plus-circle" />
          <translate>New Store/Branch/Warehouse</translate>
        </b-button>
      </template>
    </page-title>

    <api-list v-if="models.stores" ref="storesList" type="stores" :model="models.stores" :quick-filters="quickFiltersSetup.stores" filter-on-mount />

    <b-modal size="lg" id="modalStoreForm" ref="modalStoreForm" :hide-footer="true" @hidden="onStoreFormHidden">
      <template #modal-title><span v-if="storeEdit.id" v-translate>Edit</span><span v-else v-translate>New</span></template>
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <store-form :key="formKey" :store="storeEdit" />
    </b-modal>
  </b-container>
</template>
<script>
import ApiList from '@/components/ApiLists/ApiList'
import StoreForm from '@/components/StoreForm'

export default {
  name: 'StoresManagementPage',
  title() {
    return this.$gettext('Stores Management')
  },
  components: {
    ApiList,
    StoreForm
  },
  data() {
    return {
      storeEdit: this.newStore(),
      formKey: 0
    }
  },
  mounted() {
    this.$root.$on('Stores::edit', this.openEdit)
    this.$root.$on('Stores::delete', this.deleteStore)
  },
  beforeDestroy() {
    this.$root.$off('Stores::edit', this.openEdit)
    this.$root.$off('Stores::delete', this.deleteStore)
  },
  methods: {
    newStore() {
      return {
        id: null,
        reference: null,
        place_id: null,
        address_extra: '',
        contact: '',
        email: '',
        phone: '',
        schedule: [],
        company_id: this.$store.getters.profile.company_id
      }
    },
    openStoreForm(store) {
      this.storeEdit = store
      // A new key re-creates StoreForm on every opening (it reads the store on created/mounted)
      this.formKey++
      this.$refs.modalStoreForm.show()
    },
    openNew() {
      this.openStoreForm(this.newStore())
    },
    openEdit(item) {
      // StoreForm mutates its store, work on a copy so a cancelled edit doesn't touch the row
      const store = JSON.parse(JSON.stringify(item))
      store.phone = store.phone || ''
      this.openStoreForm(store)
    },
    onStoreFormHidden() {
      // On @hidden StoreForm is already destroyed, so resetting its store can't break it
      this.storeEdit = this.newStore()
      this.refreshStores()
    },
    refreshStores() {
      // The address autocompletes and the map read the stores from the profile
      const refreshList = () => {
        const stores = this.profile.company?.stores || []
        if (stores.length > 0) {
          localStorage.setItem('companyStores', JSON.stringify(stores))
        } else {
          localStorage.removeItem('companyStores')
        }
        // Refresh after the profile reload (it may re-set the models) and keep the current page
        this.$root.$emit('bv::refresh::table', 'stores')
      }
      return this.$store.dispatch('fetchProfile').then(refreshList, refreshList)
    },
    deleteStore(store) {
      const translate = this.$gettext('Are you sure you want to DELETE the Store/Branch/Warehouse %{storeReference}? Please be careful, this action CANNOT be undone.')
      if (confirm(this.$gettextInterpolate(translate, { storeReference: store.reference })) === true) {
        this.$http.delete(this.$appConfig.api.baseUrl + 'companies/' + this.profile.company_id + '/stores/' + store.id)
          .then(() => {
            this.refreshStores()
          })
          .catch(() => {
            this.makeToast(this.$gettext('Warning'), this.$gettext('The Store/Branch/Warehouse could not be deleted. Please try again.'), 'danger', false, 5000)
          })
      }
    }
  }
}
</script>
